const answerMap = new Map<string, string>([
  ["TenStar", "tenstarChoice"],
  ["TenStarNPS", "tenstarChoice"],
  ["FreeTextLarge", "verbatim"],
  ["CheckBoxChoice", "multipleChoice"],
  ["CheckBoxChoiceMultiple", "multipleChoice"],
  ["RadioChoice", "multipleChoice"],
  ["MultipleOptionChoice", "multipleChoice"],
]);

export class InterviewDetail {
  dataSurvey: string = "";
  appealStatus: "expired" | "appealable" | "pending" | undefined;
  surveyRequestId: string = "";
  productType: string = "";
  firstName: string = "";
  lastName: string = "";
  cellphone: string = "";
  emailaddress: string = "";
  productName: string = "";
  vin: string = "";
  questionCode: string = "";
  verbatim: string = "";
  tenstarChoice: string = "";
  multipleChoice: string = "";
  questionType: string = "";
  completedDate: string = "";
  completedDateTime: string = "";
  area: string = "";
  subarea: string = "";
  countryDMD: string = "";
  machineType: string = "";
  platform: string = "";
  subPlatform: string = "";
  region: string = "";
  market: string = "";
  distributorName: string = "";
  dealerName: string = "";
  agentName: string = "";
  brand: string = "";
  responseChannel: string = "";
  eventDate: string = "";
  responseDate: string = "";
  mappedAnswer: string = "";
  mainDealerName: string = "";
  dealerNetworkName: string = "";
  oicName: string = "";
  outletName: string = "";
  caseNumber: string = "";
  engineType: string = "";
  importer: string = "";
  caseType: string = "";
  caseOpenDate: string = "";
  caseCloseDate: string = "";
  recoveryPlanId: string = "";
  dealer: string = "";
  appealID: string = "";
  constructor(q?: any) {
    if (q) {
      Object.assign(this, q);
    }
    let answerKey = answerMap.get(this.questionType);
    if (answerKey && q) {
      this.mappedAnswer = q[answerKey].toLowerCase();
    } else {
      this.mappedAnswer = "";
    }
    this.caseOpenDate = q?.caseDateTimeOpened
    this.caseCloseDate = q?.caseDateTimeClosed
    this.responseDate = q?.completedDate
    this.productName = q?.model
    this.engineType = q?.engine
    this.productType = q?.vehicle
    this.responseChannel = q?.channel
    this.responseDate = q?.completedDate
    this.emailaddress = q?.emailAddress

  }
}
